import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { service } from 'common/service'

export const helpService = service
  .enhanceEndpoints({ addTagTypes: ['Help'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      createHelp: builder.mutation<Res['help'], Req['createHelp']>({
        invalidatesTags: [{ id: 'LIST', type: 'Help' }],
        query: (query: Req['createHelp']) => ({
          body: query,
          method: 'POST',
          url: `community/support`,
        }),
      }),
      // END OF ENDPOINTS
    }),
  })

export async function createHelp(
  store: any,
  data: Req['createHelp'],
  options?: Parameters<typeof helpService.endpoints.createHelp.initiate>[1],
) {
  store.dispatch(helpService.endpoints.createHelp.initiate(data, options))
  return Promise.all(store.dispatch(helpService.util.getRunningQueriesThunk()))
}
// END OF FUNCTION_EXPORTS

export const {
  useCreateHelpMutation,
  // END OF EXPORTS
} = helpService

/* Usage examples:
const { data, isLoading } = useGetHelpQuery({ id: 2 }, {}) //get hook
const [createHelp, { isLoading, data, isSuccess }] = useCreateHelpMutation() //create hook
helpService.endpoints.getHelp.select({id: 2})(store.getState()) //access data from any function
*/
